import { DIRECT_CHANNEL_TYPE } from './directChannelType';
import { OBSERVATION_TYPE } from './observationType';

export const MAX_CHARS = 25;
export const DEFAULT_EXP = 0;

export const DEFAULT_APPRAISER_DATA = {
  willingToTravelToAfrica: false,
  willingToTravelToAsia: false,
  willingToTravelToAustralia: false,
  willingToTravelToEurope: false,
  willingToTravelToNorthAmerica: false,
  willingToTravelToSouthAmerica: false,
  willingToTravelToVirtual: false,
  directChannel: DIRECT_CHANNEL_TYPE.NA,
  observation: OBSERVATION_TYPE.NA
};
